import styled from '@emotion/styled'

export const GraphWrapper = styled.div`
  position: relative;
  width: 200px;
  height: 200px;
  z-index: 0;
`

export const TextOverlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  align-items: center;
  justify-content: center;
  z-index: -1;
`
